import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import { Icon } from "@iconify/react/dist/iconify.js";
import "react-toastify/dist/ReactToastify.css";

const baseUrl = process.env.REACT_APP_API ;

const SignInLayer = () => {
  const imagePath = `${process.env.PUBLIC_URL}/assets/images/crebaco-logo.webp`;
  const imagePath2 = `${process.env.PUBLIC_URL}/assets/images/MarketMaking.png`;
  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [loginloading, setLoginLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault(); 
    setLoginLoading(true);
    try {
      const response = await fetch(`${baseUrl}/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }), //  Ensure JSON format
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }
      NotificationManager.success('Login successful!');
      sessionStorage.setItem("AuthToken", data.token);
      navigate("/bitmart"); // Redirect to dashboard
    } catch (error) {
      NotificationManager.error(error.message || "Login failed. Please try again.");
    }
    finally {
      setLoginLoading(false);
    }
  };

  // Utility to fetch IP address
  const fetchIPAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      if (!response.ok) throw new Error("Failed to fetch IP address");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Error fetching IP address:", error);
      return null;
    }
  };

  // Utility to determine platform
  const getPlatform = () =>
    typeof window.MyAppBridge !== "undefined" ? "app" : "web";

  // Extract device name from user agent
  const getDeviceName = () => {
    const userAgent = navigator.userAgent;
    const matches = userAgent.match(/\(([^)]+)\)/);
    return matches ? matches[1] : "Unknown";
  };

  // Generate session data
  const createSessionData = async () => ({
    status: "active",
    platform: getPlatform(),
    deviceName: getDeviceName(),
    locationIp: await fetchIPAddress(),
  });

  useEffect(() => {
    const timeout = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading-screen">
          <div className="logo-container">
            <img src={imagePath} alt="Blue Aster Logo" />
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <section className="auth bg-base d-flex flex-wrap">
          <div className="auth-left d-lg-block d-none">
            <div className="d-flex align-items-center flex-column h-100 justify-content-center">
           <img src={imagePath2} alt="" style={{ height: '1056px', width:'1064px'}} />
            </div>
          </div>
          <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
            <div className="max-w-464-px mx-auto w-100">
              <>
                <div>
                  <Link to="/" className="mb-40 max-w-290-px">
                    <img src={imagePath} alt="" />
                  </Link>
                  <h4 className="mb-12">Sign In to your Account</h4>
                  <p className="mb-32 text-secondary-light text-lg">
                    Welcome back! Please enter your details
                  </p>
                </div>
                <form onSubmit={handleLogin}>
                  <div className="icon-field mb-16">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="mage:email" />
                    </span>
                    <input
                      type="username"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      placeholder="username"
                      value={username}
                      onChange={(e) => setusername(e.target.value)}
                      required
                    />
                  </div>
                  <div className="position-relative mb-20">
                    <div className="icon-field">
                      <span className="icon top-50 translate-middle-y">
                        <Icon icon="solar:lock-password-outline" />
                      </span>
                      <input
                        type="password"
                        className="form-control h-56-px bg-neutral-50 radius-12"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  {/* <div className="d-flex justify-content-between gap-2">
                    <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input border border-neutral-300"
                        type="checkbox"
                        id="remember"
                      />
                      <label className="form-check-label" htmlFor="remember">
                        Remember me
                      </label>
                    </div>
                    <Link
                      to="/forgot-password"
                      className="text-primary-600 fw-medium"
                    >
                      Forgot Password?
                    </Link>
                  </div> */}
                  <button
                    type="submit"
                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                  >
                  {loginloading? 'Signing..': 'Sign In'}  
                  </button>
                  {/* <div className="text-center text-sm">
                    <p className="mb-0">
                      Don't have an account?{" "}
                      <Link
                        to="/sign-up"
                        className="text-primary-600 fw-semibold"
                      >
                        Sign Up
                      </Link>
                    </p>
                  </div> */}
                </form>
              </>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default SignInLayer;
